import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api` });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("carestop_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}

export const ROLE_LABELS = {
  admin: "Admin", doctor: "Doctor", staff: "Clinic Staff", lab: "Lab", patient: "Patient", nutritionist: "Nutritionist", insurance: "Insurance", dx: "DX Brand", medtech: "Medtech Brand",
};

export const ORDER_STATUS_LABELS = {
  recommended: "Recommended", ordered: "Ordered", sample_collected: "Sample collected", result_ready: "Result ready", cancelled: "Cancelled",
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString("en-IN", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" }) : "—");
